var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.totalPagesCount)?_c('div',{staticClass:"pag-nav"},[_vm._l((_vm.pagesNumerics),function(page,index){return [(!page)?_c('div',{key:("x" + index),staticClass:"dots"},[_vm._v("\n      . . .\n    ")]):_c('div',{key:page,staticClass:"one",class:{ active: (page - 1) === _vm.pagination.page },on:{"click":function($event){_vm.$emit('change', page - 1)}}},[_vm._v("\n    "+_vm._s(page)+"\n  ")])]})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56c36e0d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/PaginationNav.vue
// module id = 380
// module chunks = 8